import React from 'react';
import './styles.scss';
import { connect } from 'react-redux';
import { 
  setSafetyBarrierExternalDirection, 
  setSafetyBarrierInternalDirectionType,
  setSafetyBarrierLoadBetweenPosts,
  setSafetyBarrierLoadPerLength,
  toggleSafetyBarriersInternalDirection
} from '@reducers/selectors/loads/actions';

import Input from "@components/Input";
import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { APP_TEXTS } from '@texts';
import { LOAD } from '@reducers/units';
import { INTERNAL_TYPES, EXTERNAL_TYPES } from '@reducers/selectors/loads';

const SafetyBarrierLocation = props => (
  <div className="calculation design-loading">
    <section className="list-type">

      <section className="list-type">
        <h4>{APP_TEXTS.LOAD_PER_LENGTH_EXTERNAL_DIRECTION.Content}</h4>

        <div className="form-check mb-1">
          <label className="form-check-label" htmlFor={EXTERNAL_TYPES.DOMESTIC_AND_RESIDENTIAL}>
            <input
              className="SafetyBarrierLocation__checkbox"
              id={EXTERNAL_TYPES.DOMESTIC_AND_RESIDENTIAL}
              name="external_direction"
              checked={props.externalDirectionType === EXTERNAL_TYPES.DOMESTIC_AND_RESIDENTIAL}
              onChange={() => props.setExternal(EXTERNAL_TYPES.DOMESTIC_AND_RESIDENTIAL, 0.6)}
              type="radio"
            />
           {APP_TEXTS.DOMESTIC_AND_RESIDENTIAL_AREAS.Content + " " + 
            unitTransform(0.6, true).from(defaultUnits.LOAD).to(props.loadUnit) + " " + props.loadUnit + 
              (props.loadUnit === LOAD.POUND_FORCE ? "/ft" : "/ml")}
          </label>
        </div>

        <div className="form-check mb-1">
          <label className="form-check-label" htmlFor={EXTERNAL_TYPES.OFFICE_AREAS}>
            <input
              className="SafetyBarrierLocation__checkbox"
              id={EXTERNAL_TYPES.OFFICE_AREAS}
              name="external_direction"
              checked={props.externalDirectionType === EXTERNAL_TYPES.OFFICE_AREAS}
              onChange={() => props.setExternal(EXTERNAL_TYPES.OFFICE_AREAS, 0.6)}
              type="radio"
            />
            {APP_TEXTS.OFFICE_AREAS.Content + " " + 
            unitTransform(0.6, true).from(defaultUnits.LOAD).to(props.loadUnit) + " " + props.loadUnit + 
            (props.loadUnit === LOAD.POUND_FORCE ? "/ft" : "/ml")}
          </label>
        </div>

        <div className="form-check mb-1">
          <label className="form-check-label" htmlFor={EXTERNAL_TYPES.PUBLIC_BUILDINGS}>
            <input
              className="SafetyBarrierLocation__checkbox"
              id={EXTERNAL_TYPES.PUBLIC_BUILDINGS}
              name="external_direction"
              checked={props.externalDirectionType === EXTERNAL_TYPES.PUBLIC_BUILDINGS}
              onChange={() => props.setExternal(EXTERNAL_TYPES.PUBLIC_BUILDINGS, 1.0)}
              type="radio"
            />
            {APP_TEXTS.PUBLIC_BUILDINGS_MEETING_ROOMS.Content + " " + 
            unitTransform(1.0, true).from(defaultUnits.LOAD).to(props.loadUnit) + " " + props.loadUnit + 
            (props.loadUnit === LOAD.POUND_FORCE ? "/ft" : "/ml")}
          </label>
        </div>

        <div className="form-check mb-1">
          <label className="form-check-label" htmlFor={EXTERNAL_TYPES.SHOPPING_AREAS}>
            <input
              className="SafetyBarrierLocation__checkbox"
              id={EXTERNAL_TYPES.SHOPPING_AREAS}
              name="external_direction"
              checked={props.externalDirectionType === EXTERNAL_TYPES.SHOPPING_AREAS}
              onChange={() => props.setExternal(EXTERNAL_TYPES.SHOPPING_AREAS, 1.0)}
              type="radio"
            />
            {APP_TEXTS.SHOPPING_AREAS.Content + " " + 
            unitTransform(1.0, true).from(defaultUnits.LOAD).to(props.loadUnit) + " " + props.loadUnit + 
            (props.loadUnit === LOAD.POUND_FORCE ? "/ft" : "/ml")}
          </label>
        </div>

        <div className="form-check mb-1">
          <label className="form-check-label" htmlFor={EXTERNAL_TYPES.INDUSTRIAL_AREAS_SUSCEPTIBLE}>
            <input
              className="SafetyBarrierLocation__checkbox"
              id={EXTERNAL_TYPES.INDUSTRIAL_AREAS_SUSCEPTIBLE}
              name="external_direction"
              checked={props.externalDirectionType === EXTERNAL_TYPES.INDUSTRIAL_AREAS_SUSCEPTIBLE}
              onChange={() => props.setExternal(EXTERNAL_TYPES.INDUSTRIAL_AREAS_SUSCEPTIBLE, 0.8)}
              type="radio"
            />
           {APP_TEXTS.INDUSTRIAL_AREAS_E1.Content + " " + 
            unitTransform(0.8, true).from(defaultUnits.LOAD).to(props.loadUnit) + " " + props.loadUnit + 
            (props.loadUnit === LOAD.POUND_FORCE ? "/ft" : "/ml")}
          </label>
        </div>

        <div className="form-check mb-1">
          <label className="form-check-label" htmlFor={EXTERNAL_TYPES.INDUSTRIAL_AREAS}>
            <input
              className="SafetyBarrierLocation__checkbox"
              id={EXTERNAL_TYPES.INDUSTRIAL_AREAS}
              name="external_direction"
              checked={props.externalDirectionType === EXTERNAL_TYPES.INDUSTRIAL_AREAS}
              onChange={() => props.setExternal(EXTERNAL_TYPES.INDUSTRIAL_AREAS, 0.3)}
              type="radio"
            />
            {APP_TEXTS.INDUSTRIAL_AREAS_E2.Content + " " + 
            unitTransform(0.3, true).from(defaultUnits.LOAD).to(props.loadUnit) + " " + props.loadUnit + 
            (props.loadUnit === LOAD.POUND_FORCE ? "/ft" : "/ml")}
          </label>
        </div>

        <div className="form-check mb-1">
          <label className="form-check-label" htmlFor={EXTERNAL_TYPES.SPECTATORS_FACILITIES}>
            <input
              className="SafetyBarrierLocation__checkbox"
              id={EXTERNAL_TYPES.SPECTATORS_FACILITIES}
              name="external_direction"
              checked={props.externalDirectionType === EXTERNAL_TYPES.SPECTATORS_FACILITIES}
              onChange={() => props.setExternal(EXTERNAL_TYPES.SPECTATORS_FACILITIES, 1.7)}
              type="radio"
            />
           {APP_TEXTS.STADIUM_LARGE_CROWDS_C5.Content + " " + 
            unitTransform(1.7, true).from(defaultUnits.LOAD).to(props.loadUnit) + " " + props.loadUnit + 
            (props.loadUnit === LOAD.POUND_FORCE ? "/ft" : "/ml")}
          </label>
        </div>

        <div className="form-check mb-1">
          <label className="form-check-label align-items-center" htmlFor={EXTERNAL_TYPES.EXTERNAL_DIRECTION_CUSTOM}>
            <input
              className="SafetyBarrierLocation__checkbox"
              id={EXTERNAL_TYPES.EXTERNAL_DIRECTION_CUSTOM}
              name="external_direction"
              checked={props.externalDirectionType === EXTERNAL_TYPES.EXTERNAL_DIRECTION_CUSTOM}
              onChange={() => {
                props.setExternal(
                  EXTERNAL_TYPES.EXTERNAL_DIRECTION_CUSTOM,
                  props.customExternalValue,
                  true
                );
              }}
              type="radio"
            />

            {APP_TEXTS.LABEL_CUSTOM.Content}&nbsp;
            <Input
              className="SafetyBarrierLocation__label"
              postfix={unitLabel(props.loadUnit) + (props.loadUnit === LOAD.POUND_FORCE ? "/ft" : "/ml")}
              id="external_direction_custom_input"
              value={unitTransform(props.customExternalValue).from(defaultUnits.LOAD).to(props.loadUnit)}
              type="number"
              onUpdate={value => {
                props.setExternal(
                  EXTERNAL_TYPES.EXTERNAL_DIRECTION_CUSTOM,
                  unitTransform(value, false).from(props.loadUnit).to(defaultUnits.LOAD),
                  true
                );
              }}
              />
            </label>
        </div>
      </section>

      <section className="list-type">
        <label className="form-check-label" htmlFor="internal_direction_toggle">
          <input
            className="mb-2 mr-2"
            id="internal_direction_toggle"
            type="checkbox"
            checked={props.hasInternalDirection}
            onChange={() => {
              props.toggleInternalDirection(!props.hasInternalDirection);
            }}
          />
          <h4>
            <span className="ml-1 w-100">
              {APP_TEXTS.SAFETY_BARRIERS_INTERNAL_DIRECTION.Content}
            </span>
          </h4>
        </label>
        
        <div className="form-check mb-1">
          <label className="form-check-label SafetyBarrierLocation__internal__label" htmlFor={INTERNAL_TYPES.CUSTOM_BETWEEN_POSTS}>
            <input
              className="SafetyBarrierLocation__checkbox"
              id={INTERNAL_TYPES.CUSTOM_BETWEEN_POSTS}
              checked={props.internalDirectionType === INTERNAL_TYPES.CUSTOM_BETWEEN_POSTS}
              disabled={!props.hasInternalDirection}
              onChange={() => {
                props.setInternalType(INTERNAL_TYPES.CUSTOM_BETWEEN_POSTS);
              }}
              type="radio"
            />

            {APP_TEXTS.SAFETY_BARRIERS_LOAD_BETWEEN_POSTS.Content}&nbsp;
          </label>
          
          <Input
            className="SafetyBarrierLocation__internal"
            postfix={unitLabel(props.loadUnit)}
            id="internal_load_between_posts_input"
            value={unitTransform(props.internalLoadBetweenPosts).from(defaultUnits.LOAD).to(props.loadUnit)}
            type="number"
            disabled={!props.hasInternalDirection || props.internalDirectionType !== INTERNAL_TYPES.CUSTOM_BETWEEN_POSTS}
            onUpdate={value => {
              props.setInternalLoadBetweenPosts(unitTransform(value, false).from(props.loadUnit).to(defaultUnits.LOAD));
            }}
          />
        </div> 

        <div className="form-check mb-1">
          <label className="form-check-label SafetyBarrierLocation__internal__label" htmlFor={INTERNAL_TYPES.CUSTOM_PER_LENGTH}>
            <input
              className="SafetyBarrierLocation__checkbox"
              id={INTERNAL_TYPES.CUSTOM_PER_LENGTH}
              checked={props.internalDirectionType === INTERNAL_TYPES.CUSTOM_PER_LENGTH}
              disabled={!props.hasInternalDirection}
              onChange={() => {
                props.setInternalType(INTERNAL_TYPES.CUSTOM_PER_LENGTH);
              }}
              type="radio"
            />

            {APP_TEXTS.SAFETY_BARRIERS_LOAD_PER_LENGTH.Content}&nbsp;
          </label>
            
            <Input
              className="SafetyBarrierLocation__internal"
              postfix={unitLabel(props.loadUnit) + (props.loadUnit === LOAD.POUND_FORCE ? "/ft" : "/ml")}
              id="internal_load_per_length_input"
              value={unitTransform(props.internalLoadPerLength).from(defaultUnits.LOAD).to(props.loadUnit)}
              type="number"
              disabled={!props.hasInternalDirection || props.internalDirectionType !== INTERNAL_TYPES.CUSTOM_PER_LENGTH}
              onUpdate={value => {
                props.setInternalLoadPerLength(unitTransform(value, false).from(props.loadUnit).to(defaultUnits.LOAD));
              }}
              />
        </div>
      </section>
    </section>
  </div>
);

const mapState = state => ({
  loadUnit: state.main.units.load,
  customExternalValue: (() => {
    if (state.selectors.loads[state.main.appType].externalDirection.type === EXTERNAL_TYPES.EXTERNAL_DIRECTION_CUSTOM) {
      return +state.selectors.loads[state.main.appType].externalDirection.value;
    }

      return 0.4; // default 40 daN
  })(),
  externalDirectionType: state.selectors.loads[state.main.appType].externalDirection.type,
  internalDirectionType: state.selectors.loads[state.main.appType].internalDirection.type,
  hasInternalDirection: state.selectors.loads[state.main.appType].hasInternalDirection,
  internalLoadBetweenPosts: state.selectors.loads[state.main.appType].internalDirection.loadBetweenPosts,
  internalLoadPerLength: state.selectors.loads[state.main.appType].internalDirection.loadPerLength,
  appStatus: state.main.status // use it as a hack to render a potential language change
});

const mapDispatch = dispatch => ({
  setExternal: (type, value, isCustom) => dispatch(setSafetyBarrierExternalDirection(type, value, isCustom)),
  setInternalType: (type) => dispatch(setSafetyBarrierInternalDirectionType(type)),
  setInternalLoadBetweenPosts: (value) => dispatch(setSafetyBarrierLoadBetweenPosts(value)),
  setInternalLoadPerLength: (value) => dispatch(setSafetyBarrierLoadPerLength(value)),
  toggleInternalDirection: (value) => dispatch(toggleSafetyBarriersInternalDirection(value))
});

export default connect(mapState, mapDispatch)(SafetyBarrierLocation);



// WEBPACK FOOTER //
// ./src/views/Loads/SafetyBarriers/SafetyBarrierLocation/index.js